import {
	Component,
	ElementRef,
	OnDestroy,
	OnInit,
	ViewChild,
} from '@angular/core';
import {
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { AddressConstants } from '../../../../modules/address/address.constants';
import {
	CONTRACT_MODEL,
	INCLUSION_RULES,
	PolicyAdRules,
	PolicyApRules,
	PolicyPayments,
	PolicyRequest,
} from '../../models/policies.model';
import { PositionSummary } from '../../models/positions.model';
import {
	editPolicyRegStart,
	fetchUFCitiesClear,
	fetchUFCitiesStart,
	fetchPolicyRegStart,
	fetchOrgPositionsStart,
	createPolicyStart,
	restoreFormReset,
} from '../../state/organizations.actions';
import {
	selectCities,
	selectPolicy,
	selectPositions,
	selectRestoreForm,
} from '../../state/organizations.selector';

import { PositionModalComponent } from './position-modal/position-modal.component';

@Component({
	selector: 'app-position-alert-dialog',
	template: `
		<app-dialog
			modalTitle="Atenção"
			titleButton="Sim"
			secTitleButton="Não"
			[secButton]="true"
			[asAlert]="true"
			(dialogClose)="dialogRef.close()"
			(dialogSave)="dialogRef.close(true)"
		>
			<p class="lh-md">
				As alterações no política não afetarão os beneficiários imediatamente.
				Você deverá fazer a alteração direto no cadastro do beneficiário. Tem
				certeza que deseja continuar?
			</p>
		</app-dialog>
	`,
})
export class PolicyAlertDialogComponent {
	constructor(public dialogRef: MatDialogRef<PolicyAlertDialogComponent>) {}
}

@Component({
	selector: 'app-policy-registration',
	styleUrls: ['./policy-registration.component.scss'],
	templateUrl: './policy-registration.component.html',
})
export class PolicyRegistrationComponent implements OnInit, OnDestroy {
	@ViewChild('ipick') ipick!: ElementRef;

	adrForm: UntypedFormGroup;
	auxStateForm!: boolean;
	cities: string[] = [];
	contractModel = CONTRACT_MODEL;
	dialogRef!: MatDialogRef<PolicyAlertDialogComponent | PositionModalComponent>;
	enableTab = true;
	inclusionRules = INCLUSION_RULES;
	inputId: string = String(Math.random());
	loading: boolean = true;
	moreDependents: boolean = false;
	orgId: string = '';

	payForm: UntypedFormGroup;
	policiesTabs = [
		{ label: 'Política de saúde', path: 'health' },
		{ label: 'Política dental', path: 'dental' },
	];
	policyId: string = '';
	positions: PositionSummary[] = [];
	positionsIds: string[] = [];
	positionsIdsInitial: string[] = [];
	positionsInput: string = '';
	regForm: UntypedFormGroup;
	rulForm: UntypedFormGroup;

	selectedType: 'dental' | 'health' = 'health';

	uf = AddressConstants.ufLabels;

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly fb: UntypedFormBuilder,
		private readonly activatedRoute: ActivatedRoute,
		private readonly dialog: MatDialog,
		private readonly store: Store,
	) {
		this.regForm = this.fb.group({
			contract: [null, [Validators.required]],
			name: [null, [Validators.required]],
		});
		this.rulForm = this.fb.group({
			city: [{ disabled: true, value: null }],
			max_wage: [null],
			min_wage: [null],
			state: [null],
		});
		this.payForm = this.fb.group({
			fifth_dep_type: ['R$', [Validators.required]],
			fifth_dep_value: [null],
			first_dep_type: ['R$', [Validators.required]],
			first_dep_value: [null],
			fourth_dep_type: ['R$', [Validators.required]],
			fourth_dep_value: [null],
			owner_type: ['R$', [Validators.required]],
			owner_value: [null, [Validators.required]],
			second_dep_type: ['R$', [Validators.required]],
			second_dep_value: [null],
			sixth_dep_type: ['R$', [Validators.required]],
			sixth_dep_value: [null],
			spouse_type: ['R$', [Validators.required]],
			spouse_value: [null],
			third_dep_type: ['R$', [Validators.required]],
			third_dep_value: [null],
		});
		this.adrForm = this.fb.group({
			days: [null],
			inclusion_rule: [null, [Validators.required]],
			max_age: [null, [Validators.required]],
		});
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		this.store.dispatch(fetchUFCitiesClear());
		this.store.dispatch(restoreFormReset());
	}

	ngOnInit(): void {
		this.activatedRoute.params.subscribe(({ id, politicaId, politicaTipo }) => {
			this.orgId = id;
			this.store.dispatch(fetchOrgPositionsStart({ id }));
			if (!politicaId) {
				this.auxStateForm = true;
				this.loading = false;
			} else {
				this.policyId = politicaId;

				this.selectedType = politicaTipo;
				this.store
					.select(selectPolicy)
					.pipe(takeUntil(this.unsubscribe$))
					.subscribe((p) => {
						if (p) {
							this.enableTab = false;
							this.regForm = this.fb.group({
								contract: [p.contract, [Validators.required]],
								name: [p.name, [Validators.required]],
							});
							this.rulForm = this.fb.group({
								city: [{ disabled: true, value: p.policy_rules.city }],
								max_wage: [
									p.policy_rules.max_wage
										? p.policy_rules.max_wage.replace('.', ',')
										: null,
								],
								min_wage: [
									p.policy_rules.min_wage
										? p.policy_rules.min_wage.replace('.', ',')
										: null,
								],
								state: [p.policy_rules.state],
							});
							this.payForm = this.fb.group({
								fifth_dep_type: [
									p.payments.fifth_dep_type,
									[Validators.required],
								],
								fifth_dep_value: [
									p.payments.fifth_dep_value
										? p.payments.fifth_dep_value.replace('.', ',')
										: null,
								],
								first_dep_type: [
									p.payments.first_dep_type,
									[Validators.required],
								],
								first_dep_value: [
									p.payments.first_dep_value
										? p.payments.first_dep_value.replace('.', ',')
										: null,
								],
								fourth_dep_type: [
									p.payments.fourth_dep_type,
									[Validators.required],
								],
								fourth_dep_value: [
									p.payments.fourth_dep_value
										? p.payments.fourth_dep_value.replace('.', ',')
										: null,
								],
								owner_type: [p.payments.owner_type, [Validators.required]],
								owner_value: [
									p.payments.owner_value || p.payments.owner_value === '0'
										? p.payments.owner_value.replace('.', ',')
										: null,
									[Validators.required],
								],
								second_dep_type: [
									p.payments.second_dep_type,
									[Validators.required],
								],
								second_dep_value: [
									p.payments.second_dep_value
										? p.payments.second_dep_value.replace('.', ',')
										: null,
								],
								sixth_dep_type: [
									p.payments.sixth_dep_type,
									[Validators.required],
								],
								sixth_dep_value: [
									p.payments.sixth_dep_value
										? p.payments.sixth_dep_value.replace('.', ',')
										: null,
								],
								spouse_type: [p.payments.spouse_type, [Validators.required]],
								spouse_value: [
									p.payments.spouse_value
										? p.payments.spouse_value.replace('.', ',')
										: null,
								],
								third_dep_type: [
									p.payments.third_dep_type,
									[Validators.required],
								],
								third_dep_value: [
									p.payments.third_dep_value
										? p.payments.third_dep_value.replace('.', ',')
										: null,
								],
							});
							this.adrForm = this.fb.group({
								days: [p.days ? p.days : null],
								inclusion_rule: [p.inclusion_rule],
								max_age: [p.max_age],
							});
							this.positionsIds = p.positions.map((p) => p.id);
							this.positionsIdsInitial = p.positions.map((p) => p.id);
							this.positionsInput = p.positions.map((p) => p.name).toString();
							if (
								p.payments.fourth_dep_value ||
								p.payments.fifth_dep_value ||
								p.payments.sixth_dep_value
							) {
								this.moreDependents = true;
							}
							this.auxStateForm = false;
							this.loading = false;
						}
					});
				this.store.dispatch(
					fetchPolicyRegStart({
						id,
						policyId: politicaId,
						policyType: politicaTipo,
					}),
				);
			}
		});
		this.store
			.select(selectPositions)
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((positions) => {
				if (positions) {
					this.positions = positions;
				}
			});
		this.store
			.select(selectCities)
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((cities) => {
				if (cities.length) {
					this.rulForm.get('city')!.enable();
				}
				this.cities = cities;
			});
	}

	onInclusionRuleChange(rule: 'IMEDIATO' | 'NUMERO_DIAS'): void {
		if (rule === 'NUMERO_DIAS') {
			this.adrForm.get('days')!.setValidators(Validators.required);
		} else {
			this.adrForm.get('days')!.setValidators([]);
			this.adrForm.get('days')!.setValue(null);
		}
		this.adrForm.get('days')!.updateValueAndValidity({ onlySelf: true });
	}

	onSubmit(): void {
		const request = this.processForm();

		if (request) {
			this.store
				.select(selectRestoreForm)
				.pipe(takeUntil(this.unsubscribe$))
				.subscribe((restore) => {
					if (restore) {
						this.updateValidation();
						this.loading = false;
					}
				});
			if (this.policyId) {
				this.dialogRef = this.dialog.open(PolicyAlertDialogComponent, {
					disableClose: true,
				});
				this.dialogRef.afterClosed().subscribe((save: boolean) => {
					if (save) {
						request.positions_disconnect = this.positionsIdsInitial.filter(
							(pi) => !this.positionsIds.includes(pi),
						);
						this.store.dispatch(
							editPolicyRegStart({
								id: this.orgId,
								policyId: this.policyId,
								request,
							}),
						);
						this.loading = true;
					}
				});
			} else {
				this.store.dispatch(createPolicyStart({ id: this.orgId, request }));
			}
		}
	}

	onTabClick(policyType: string): void {
		if (!(policyType !== 'health' && policyType !== 'dental')) {
			this.selectedType = policyType;
		}
	}

	onUFChange(id: number): void {
		this.rulForm.get('city')!.setValue(null);
		this.rulForm.get('city')!.disable();
		this.auxStateForm = true;
		if (id !== -1) {
			this.store.dispatch(fetchUFCitiesStart({ id }));
		}
	}

	openPositionsModal(): void {
		this.dialogRef = this.dialog.open(PositionModalComponent, {
			data: { positions: this.positions, selected: this.positionsIds },
			maxWidth: undefined,
		});
		this.dialogRef.afterClosed().subscribe((result: PositionSummary[]) => {
			if (!(!result || result === undefined)) {
				const ids = result.map((p: PositionSummary) => p.id);
				const names = result.map((p: PositionSummary) => p.name);
				this.positionsIds = ids;
				this.positionsInput = names.toString().replace(',', ', ');
				this.regForm.markAllAsTouched();
			}
		});
	}

	processAddRulesForm(): PolicyAdRules {
		const form = this.adrForm.value;
		form.max_age = Number(form.max_age);
		form.days = form.days ? Number(form.days) : null;

		return form;
	}

	processAppRulesForm(): PolicyApRules {
		const form = this.rulForm.value;
		form.state = form.state ? form.state : null;
		form.city = form.city ? form.city : null;
		form.min_wage = form.min_wage
			? Number(String(form.min_wage.replace(',', '.')))
			: null;
		form.max_wage = form.max_wage
			? Number(String(form.max_wage.replace(',', '.')))
			: null;

		return form;
	}

	processForm(): PolicyRequest | null {
		if (
			this.regForm.invalid ||
			this.payForm.invalid ||
			this.rulForm.invalid ||
			this.adrForm.invalid
		) {
			return null;
		}

		const application_rules = this.processAppRulesForm();
		const payments = this.processPaymentsForm();
		const additional_rules = this.processAddRulesForm();
		const req: PolicyRequest = {
			...this.regForm.value,
			...additional_rules,
			application_rules,
			dental_plan: this.selectedType === 'dental',
			health_plan: this.selectedType === 'health',
			payments,
			position_ids: this.positionsIds,
		};

		return req;
	}

	processPaymentsForm(): PolicyPayments {
		const form = this.payForm.value;
		form.owner_value = Number(String(form.owner_value).replace(',', '.'));
		form.spouse_value = form.spouse_value
			? Number(String(form.spouse_value).replace(',', '.'))
			: null;
		form.first_dep_value = form.first_dep_value
			? Number(String(form.first_dep_value).replace(',', '.'))
			: null;
		form.second_dep_value = form.second_dep_value
			? Number(String(form.second_dep_value).replace(',', '.'))
			: null;
		form.third_dep_value = form.third_dep_value
			? Number(String(form.third_dep_value).replace(',', '.'))
			: null;
		form.fourth_dep_value = form.fourth_dep_value
			? Number(String(form.fourth_dep_value).replace(',', '.'))
			: null;
		form.fifth_dep_value = form.fifth_dep_value
			? Number(String(form.fifth_dep_value).replace(',', '.'))
			: null;
		form.sixth_dep_value = form.sixth_dep_value
			? Number(String(form.sixth_dep_value).replace(',', '.'))
			: null;

		return form;
	}

	shouldDisableSaveBtn(): boolean {
		return (
			this.regForm.invalid ||
			this.rulForm.invalid ||
			this.payForm.invalid ||
			this.adrForm.invalid ||
			(this.regForm.untouched &&
				this.rulForm.untouched &&
				this.payForm.untouched &&
				this.adrForm.untouched)
		);
	}

	updateInputType(control: string, value: string): void {
		const valueControl = control.replace('type', 'value');
		this.payForm.get(control)!.setValue(value);
		this.payForm.get(valueControl)!.setValue(0);
	}

	updateValidation(): void {
		for (const control in this.regForm.controls) {
			this.regForm.get(control)!.markAsTouched();
			this.regForm.get(control)!.updateValueAndValidity({ onlySelf: true });
		}

		for (const control in this.rulForm.controls) {
			this.rulForm.get(control)!.markAsTouched();
			this.rulForm.get(control)!.updateValueAndValidity({ onlySelf: true });
		}

		for (const control in this.payForm.controls) {
			this.payForm.get(control)!.markAsTouched();
			this.payForm.get(control)!.updateValueAndValidity({ onlySelf: true });
		}

		for (const control in this.adrForm.controls) {
			this.adrForm.get(control)!.markAsTouched();
			this.adrForm.get(control)!.updateValueAndValidity({ onlySelf: true });
		}
	}
}
